// client/src/coms/views/canvas_parts/canvas_room_view_parts/brushImport/hash.js
//
// Content hashes identify duplicate brushes and shared texture assets. SHA-256
// via WebCrypto where available (secure contexts and workers); otherwise a
// 2x32-bit FNV-1a, which is only used for de-duplication, never security.

function toBytes(part) {
  if (part instanceof Uint8Array) return part;
  if (part instanceof ArrayBuffer) return new Uint8Array(part);
  if (ArrayBuffer.isView(part)) return new Uint8Array(part.buffer, part.byteOffset, part.byteLength);
  return new TextEncoder().encode(String(part == null ? '' : part));
}

function concat(parts) {
  const list = parts.map(toBytes);
  const total = list.reduce((sum, item) => sum + item.length + 4, 0);
  const out = new Uint8Array(total);
  let offset = 0;
  list.forEach((item) => {
    out[offset] = item.length >>> 24;
    out[offset + 1] = (item.length >>> 16) & 255;
    out[offset + 2] = (item.length >>> 8) & 255;
    out[offset + 3] = item.length & 255;
    out.set(item, offset + 4);
    offset += item.length + 4;
  });
  return out;
}

export function fallbackHash(bytes) {
  let a = 0x811c9dc5;
  let b = 0x01000193 ^ bytes.length;
  for (let i = 0; i < bytes.length; i += 1) {
    a = Math.imul(a ^ bytes[i], 0x01000193) >>> 0;
    b = Math.imul(b ^ bytes[bytes.length - 1 - i], 0x01000193) >>> 0;
  }
  return 'fnv-' + a.toString(16).padStart(8, '0') + b.toString(16).padStart(8, '0') + bytes.length.toString(16);
}

export async function hashBytes(parts) {
  const bytes = concat(Array.isArray(parts) ? parts : [parts]);
  const subtle = typeof crypto !== 'undefined' && crypto && crypto.subtle ? crypto.subtle : null;
  if (subtle && typeof subtle.digest === 'function') {
    try {
      const digest = new Uint8Array(await subtle.digest('SHA-256', bytes));
      let hex = '';
      for (let i = 0; i < digest.length; i += 1) hex += digest[i].toString(16).padStart(2, '0');
      return 'sha256-' + hex;
    } catch {}
  }
  return fallbackHash(bytes);
}
